/**
 * @Description 对象深拷贝
 * @author shuo.li
 * @date 2021-11-3 11:12
 * @lastEditors
 * @lastEditTime
 * @param {Any} source
 * @returns {Any}
 */
export function cloneDeep(source) {
  let o;
  // 如果  他是对象object的话  , 因为null,object,array  也是'object';
  if (typeof source === "object") {
    // 如果  他是空的话
    if (source === null) {
      o = null;
    } else {
      // 如果  他是数组arr的话
      if (source instanceof Array) {
        o = [];
        for (let i = 0, len = source.length; i < len; i++) {
          o.push(cloneDeep(source[i]));
        }
      } else {
        // 如果  他是对象object的话
        o = {};
        for (const j in source) {
          o[j] = cloneDeep(source[j]);
        }
      }
    }
  } else {
    o = source;
  }
  return o;
}
